import React from 'react';
import SvgIcon from './SvgIcon';

const FacilityHome = props => (
    <SvgIcon {...props}>
        <g id="Icon-Audit-v1.3" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="Stabilitas-Icons-Copy" transform="translate(-1853.000000, -3892.000000)">
                <g id="icon/facilities-home-copy" transform="translate(1853.000000, 3892.000000)">
                    <rect id="Rectangle-Copy-2" x="0" y="0" width="48" height="48"></rect>
                    <path
                        d="M47.2894835,20.489824 L47.2414844,20.4518237 L25.2418719,2.45169953 C24.5053255,1.84943349 23.446463,1.84943349 22.7099165,2.45169953 L0.710304061,20.4518237 C-0.12476135,21.1564193 -0.239834331,22.4007931 0.451859871,23.2465821 C1.14355407,24.0923711 2.3859871,24.2265093 3.24225946,23.5478451 L5.9762113,21.3118297 L5.9762113,43.9999862 C5.9762113,45.1045633 6.87162603,46 7.97617607,46 L39.9756124,46 C41.0801624,46 41.9755771,45.1045633 41.9755771,43.9999862 L41.9755771,21.3118297 L44.709529,23.5478451 C45.5539575,24.2602973 46.8160445,24.1532926 47.5284793,23.3088434 C48.2409141,22.4643942 48.133912,21.2022762 47.2894835,20.489824 Z"
                        id="Shape"
                        fill="currentColor"
                        fillRule="nonzero"
                    ></path>
                </g>
            </g>
        </g>
    </SvgIcon>
);

FacilityHome.displayName = 'FacilityHomeIcon';

export default FacilityHome;
